import { LegalShell, LegalSection } from "@/components/site/LegalShell";

export default function DatenschutzPage() {
  return (
    <LegalShell kicker="Rechtliches" title="Datenschutzerklärung">
      <LegalSection>
        <p>
          Der Schutz Ihrer persönlichen Daten ist uns ein wichtiges Anliegen. Wir
          behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der
          gesetzlichen Datenschutzvorschriften, insbesondere dem Schweizer
          Bundesgesetz über den Datenschutz (revDSG), sowie dieser
          Datenschutzerklärung.
        </p>
      </LegalSection>

      <LegalSection heading="1. Verantwortliche Stelle">
        <p>
          Verantwortlich für die Bearbeitung der Daten auf dieser Website ist:
        </p>
        <p>
          Liberox GmbH
          <br />
          Bodenäckerstrasse 3, 8957 Spreitenbach
          <br />
          E-Mail:{" "}
          <a
            href="mailto:labs@liberox.ch"
            className="transition-colors hover:text-[color:var(--lx-green-soft)]"
            style={{ color: "var(--lx-text)" }}
          >
            labs@liberox.ch
          </a>{" "}
          · Telefon: +41 56 561 67 62
        </p>
      </LegalSection>

      <LegalSection heading="2. Erhebung und Bearbeitung von Daten">
        <p>
          Wir bearbeiten personenbezogene Daten nur, soweit dies für die
          Bereitstellung einer funktionsfähigen Website sowie unserer Inhalte und
          Leistungen erforderlich ist. Die Bearbeitung erfolgt regelmässig nur
          nach Ihrer Einwilligung oder auf Grundlage eines berechtigten
          Interesses.
        </p>
      </LegalSection>

      <LegalSection heading="3. Kontaktformular">
        <p>
          Wenn Sie uns über das Kontaktformular Anfragen zukommen lassen, werden
          Ihre Angaben aus dem Formular (Name, E-Mail-Adresse, Firma und Ihre
          Nachricht) zwecks Bearbeitung der Anfrage und für den Fall von
          Anschlussfragen bei uns gespeichert und per E-Mail an uns übermittelt.
          Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.
        </p>
      </LegalSection>

      <LegalSection heading="4. Server-Logfiles">
        <p>
          Der Hosting-Anbieter erhebt und speichert automatisch Informationen in
          sogenannten Server-Logfiles, die Ihr Browser automatisch an uns
          übermittelt. Dies sind insbesondere: Browsertyp und -version,
          verwendetes Betriebssystem, Referrer-URL, Uhrzeit der Serveranfrage und
          IP-Adresse. Diese Daten werden nicht mit anderen Datenquellen
          zusammengeführt und dienen der technischen Sicherheit und Stabilität.
        </p>
      </LegalSection>

      <LegalSection heading="5. Weitergabe an Dritte / Auftragsbearbeiter">
        <p>
          Für den Versand der Kontaktformular-Benachrichtigungen setzen wir einen
          E-Mail-Dienstleister ein. Das Hosting der Website erfolgt über einen
          externen Anbieter. Diese Dienstleister bearbeiten Daten ausschliesslich
          in unserem Auftrag und sind vertraglich zur Einhaltung des
          Datenschutzes verpflichtet.
        </p>
      </LegalSection>

      <LegalSection heading="6. Cookies">
        <p>
          Diese Website verwendet keine Tracking- oder Marketing-Cookies. Es
          werden lediglich technisch notwendige Daten verarbeitet, die für den
          Betrieb der Website erforderlich sind.
        </p>
      </LegalSection>

      <LegalSection heading="7. SSL-/TLS-Verschlüsselung">
        <p>
          Diese Website nutzt aus Sicherheitsgründen und zum Schutz der
          Übertragung vertraulicher Inhalte eine SSL-/TLS-Verschlüsselung. Eine
          verschlüsselte Verbindung erkennen Sie an „https://“ in der Adresszeile
          Ihres Browsers.
        </p>
      </LegalSection>

      <LegalSection heading="8. Ihre Rechte">
        <p>
          Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre
          gespeicherten personenbezogenen Daten sowie ein Recht auf Berichtigung,
          Löschung oder Einschränkung der Bearbeitung. Zur Ausübung Ihrer Rechte
          können Sie sich jederzeit an{" "}
          <a
            href="mailto:labs@liberox.ch"
            className="transition-colors hover:text-[color:var(--lx-green-soft)]"
            style={{ color: "var(--lx-text)" }}
          >
            labs@liberox.ch
          </a>{" "}
          wenden.
        </p>
      </LegalSection>

      <LegalSection heading="9. Änderungen">
        <p>
          Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie
          stets den aktuellen rechtlichen Anforderungen entspricht oder um
          Änderungen unserer Leistungen umzusetzen. Für Ihren erneuten Besuch gilt
          dann die neue Datenschutzerklärung.
        </p>
      </LegalSection>
    </LegalShell>
  );
}
